import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ActivityCountState } from "../../models/mp-admin/activity-count-state";

const initialState: ActivityCountState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.activityCounts.getApi, (state, action) =>
		_.set(_.cloneDeep(state), "loading", true)
	),
	on(MpAdminActions.activityCounts.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.activityCounts.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function activityCountsReducer(
	state: ActivityCountState,
	action: Action
): ActivityCountState {
	return reducer(state, action);
}
